import React, {Component} from 'react';
import { Link } from "react-router-dom";

import './App.css';
import Leben from "./Bilder/leben2.jpg";
import Sterblichkeit from "./Bilder/LandSt.JPG";
import Krankenhaus from "./Bilder/KrankenH.jpg";
import Uhr from "./Uhr";

class Home extends Component {


	UNSAFE_componentWillMount(){
		window.scrollTo(0,0);
	}


	
 render() {
  return (

		<div className="homeAppWas" >
			<div className="contentHome, Home" >	
				<div className="haupt">

				<h2>Auf dem Weg in die Neue Weltordnung NWO!</h2>
				<h1 className="GR">Der Great Reset</h1>
				<h2>Ein Mythos?<br/>Leider nein!</h2>
				
				<a className="videoTextG"  rel="noopener" href="https://www.amazon.de/s?k=the+great+reset&crid=2VB6HHRIFGRMV&sprefix=the+great%2Caps%2C114&ref=nb_sb_ss_pltr-ranker-retrain-acsession-opsacceptance_1_9" target="_blank" >
					Das Buch <br/>von Klaus Schwab auf Amazon
				</a>
				<a className="videoTextG" rel="noopener"  href="https://www.weforum.org/agenda/2020/11/the-great-reset-building-future-resilience-to-global-risks/"  target="_blank">
				Der offizielle Werbefilm<br/>vom World Economic Forum
				</a>
				<a className="videoTextG"  rel="noopener" href="https://www.youtube.com/watch?v=_GXwRlkTHCY" target="_blank" >
				"Wer hat Angst vor Klaus Schwab?"<br/>Eine kurze Zusammenfassung von Gunnar Kaiser 17.03.2022
				</a>
				

				<h2>"Ihr werdet nichts besitzen,<br/>aber glücklich sein"</h2>
				<span>(Klaus Schwab WEF)</span>
				<h4>Hat dich jemand gefragt, ob Du das auch willst?</h4>
				
					<br/>								
				
				<p className="Einleitung">                   
            		<strong>Gesunder Menschenverstand</strong> und <strong>echte Fakten</strong><br/>           	      
        		</p>
				<strong>WEF, EU, WHO, ... gleichgeschaltete Medien</strong><br/><br/>
				</div>
				<div className="Einl" >
					<p >
						Hallo, ich bin Konrad. <br/>						
						sie reden inzwischen offen von der Neuen Weltordnung, auch Agenda 2030, Build back better oder <br/><strong>Der Great Reset</strong> genannt.
						<br/>Alles hängt natürlich mit Geld zusammen.
						<br/>FIAT-Währung, Migrationskrise, Corona, der Krieg in der Ukraine, alles ein einziges perfides Spiel.
						<br/>
						<br/>Die Zugänge zu wichtigen Informationen werden leider oft versteckt oder gar gelöscht. 
						<br/>
						Sucht Euch das Thema aus, das Euch interessiert und Ihr werdet eine Auswahl von Videos finden.
						<br/><br/>
						Ich habe darauf verzichtet die Videos runterzuladen, damit Ihr bei YouTube, frei3 ... weiterstöbern könnt und Euch ein unabhängiges eigenes Bild macht.
						<br/><br/>
						Hier ein paar Links, die ich für den Einstieg empfehle:	<br/>
						Leider ist am Anfang oft Werbung.<br/>
						Nach jedem Video aktiv auf dieses Fenster zurückschalten <br/>
						oder eben weiterstöbern.				
					</p>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=LfdaICQf52g" target="_blank" >
					JAHRESRÜCKBLICK 2023 mit Antje Hermenau, Julia Szarvasy, Marco Rima und Carlos A. Gebauer
					</a>
					<a className="videoText" rel="noopener"  href="https://nacktesniveau.de/folgen/folge-117-weihnachtskrieger/" target="_blank" >
					Nacktes Niveau #117 23.12.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://auf1.tv/das-grosse-interview/heiko-schoening-sagt-voraus-angriff-aufs-mikrobiom-das-wird-groesser-als-corona" target="_blank" >
					Heiko Schöning sagt voraus: Angriff aufs „Mikrobiom“ — das wird größer als Corona! 17.12.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=SPKNCgOfdEs" target="_blank" >
					Die grüne Agenda zerstört unsere Grundversorgung! 17.12.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=HRq0iiJ1HDY" target="_blank" >
					Der Wegscheider: „Die erfolgreiche Mission Klima-Glück!“ | Wochenkommentar 09.12.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=qVZPrm4IWMw" target="_blank" >
					Dr. Markus Krall spricht über die Lage der Nation. Ein Vortrag im Hayek Verein Dresden 26.11.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=EzEN82kW7xE&t=318s" target="_blank" >
					#EMA deckt Impf-Betrug auf! Lügen über Lügen nun offiziell! #coronaaufarbeitung #projektmemento 24.11.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=tXUT2qdGBQs" target="_blank" >
					Anthony Lee: Wie die Ampel die Bauern ruiniert | Vortrag Sept. 2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=J8UZPVBU2-4&t=3085s" target="_blank" >
					Die Verweigerung von Fakten durch die GRÜNEN 19.11.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=f6olWE95h1M" target="_blank" >
					FORUM FREIHEIT 2023 Panel 01 "Macht statt Markt: Green New Deal als Systemtransformation" 05.11.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=hXOxR7874aU" target="_blank" >
					FORUM FREIHEIT 2023 Panel 02 "Ungesund: Der Einzelne, der Staat und die WHO" 06.11.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=-NQ5t62ixTI" target="_blank" >
					final 01 Panel 03 Moral als Keule Forum Freiheit 2023 06.11.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=IOQF1QwdeUg" target="_blank" >
					„Zukunft ist Herkunft – Wie wir aus der Krise kommen“ Vortrag von Peter Hahne bei Zukunft CH 27.10.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=H9jtNTBlNn4&t=10s" target="_blank" >
					Dr. Gunter Frank über Corona: Es liegen Beweise für ein Staatsverbrechen vor 14.10.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://uncutnews.ch/bevoelkerungsreduktion-wef-mitglieder-sehen-darin-schluessel-zu-globalen-problemloesungen/" target="_blank" >
					Bevölkerungsreduktion: WEF-Mitglieder sehen darin Schlüssel zu globalen Problemlösungen. 10.10.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://auf1.tv/stefan-magnet-auf1/agenda-von-faesers-verbots-hammer-aufgedeckt-deutsches-leben-kaputt-schlagen" target="_blank" >
					Agenda von Faesers Verbots-Hammer aufgedeckt: Deutsches Leben kaputt schlagen! 06.10.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=5SY8mrkqMaE" target="_blank" >
					"Die Corona-Verschwörung": Interview mit Brigitte Röhrig | Tichys Einblick Talk 29.09.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=sTFl3JPwbpY" target="_blank" >
					EuGH-Urteil: Deutschland darf keine Migranten mehr zurückweisen! Wir sind Sklaven der EU! 22.09.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.aletheia-scimed.ch/de/warnung-im-auftrag-der-medizin/" target="_blank" >
					Offener Brief eines belgischen Ärztekollektivs an die Presse und die Ärztekammer 12.09.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=DaWFFr05SzU" target="_blank" >
					Michael Limburg: CO2 – Fakten gegen Hysterie 16.09.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=8alpyuCszBE" target="_blank" >
					Im Land der Idioten -  Peter Hahne 10.09.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=VCiMnWS1ZSw" target="_blank" >
					Hans-Georg Maaßen: Endspiel um Deutschland | Vortrag 01.09.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://auf1.tv/stefan-magnet-auf1/corona-war-nur-der-anfang-auftakt-zu-globaler-kontrolle-und-great-reset/" target="_blank" >
					Corona war nur der Anfang: Auftakt zu globaler Kontrolle und Great Reset 04.09.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=tCI_u3F0nj8" target="_blank" >
					Die2 am Abend - Aktuelle Infos über die Vorgänge auf Hawaii! 30.08.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=49tHtFpaPUI" target="_blank" >
					Paul Brandenburg - Roland Tichy: Zerfall der Bundesrepublik – Wie wird das Ende aussehen? 22.08.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=tGuJu1wSv3g" target="_blank" >
					WHO und die Pandemien - TE Wecker am 19.08.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=YV4ArhNTjRk" target="_blank" >
					Wie uns der WHO-Pandemievertrag versklaven könnte 15.08.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=8t4vnX32sLU" target="_blank" >
					Dr. Werner Bergholz: Klimawandel - Wieviel ist menschengemacht? 02.08.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=_8wQqS3DTLk" target="_blank" >
					Kranke Hirne haben es auf unsere Kinder abgesehen 02.08.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://report24.news/ngos-who-und-eine-app-wer-ihrem-arzt-wirklich-vorschreibt-wie-er-sie-behandeln-soll/?feed_id=32314" target="_blank" >
					NGOs, WHO und eine App – Viele Menschen starben durch Behandlungsvorschriften 25.07.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://pressefreiheit.rtde.live/international/174350-internationale-anwaltskonferenz-wir-muessen-diktatur/" target="_blank" >
					Internationale Anwaltskonferenz: Wir müssen die Diktatur der Weltgesundheitsorganisation stoppen 04.07.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://telegra.ph/Physik-Nobelpreisträger-bezeichnet-die-Erzählung-vom-Klimanotstand-als-Pseudowissenschaft-07-18-2" target="_blank" >
					Physik-Nobelpreisträger bezeichnet die Erzählung vom „Klimanotstand“ als „Pseudowissenschaft“ 18.07.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=K_Ys52Rglk4" target="_blank" >
					#Wirhabenmitgemacht: Abrechnung mit dem Corona-Panikorchester!
					</a>
					<a className="videoText" rel="noopener"  href="https://www.bitchute.com/video/CxB0MJFe42OW/" target="_blank" >
					Versuch einer Aufarbeitung der C - Zeit. <br/>
					PROJEKT MEMENTO #1 KONRAD OBER #PROJEKT MEMENTO 10.07.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://rumble.com/v2z1v6c-maaen.html" target="_blank" >
					Rechtsextrem? Der gebührenfinanzierte Hetzjagd des ZDF auf Maaßen, für Sie dechiffriert und entlarvt 10.07.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=siPF_MN6D88" target="_blank" >
					Digitaler Euro: Kommt ein Bargeldverbot? Interview mit Markus Krall 07.07.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=JpE_jEWBB-U" target="_blank" >
					Gefahr im Verzug: Wie die WHO bis nach Deutschland durch regieren will. Ex-LKA-Chef warnt 03.07.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=-X-lHkfaA4U" target="_blank" >
					Michael Esfeld im "Land ohne Mut" 02.07.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=3L1J9HQ2Hlk" target="_blank" >
					Frankreich ist gefallen - ich spreche Klartext und nehme kein Blatt vor den Mund 01.07.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=GMOg4wJYn0A" target="_blank" >
					Folge 92 - Speck der Hoffnung / Nacktes Niveau 01.07.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=oPgNgYI2OeE" target="_blank" >
					Jeder fünfte Deutsche "brauner Bodensatz“: Verfassungsschutzchef bleibt bekräftigt Skandal-Aussage 01.07.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=xUvp5zwkprg" target="_blank" >
					Die Rede von Hans-Georg Maaßen auf der Mitgliederversammlung der WerteUnion in Erfurt am 10.06.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://reitschuster.de/post/merkels-regierungssprecherin-wird-rbb-intendantin/" target="_blank" >
					Merkels Regierungssprecherin wird RBB-Intendantin 17.06.2013
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=uEd0TxAgGIw" target="_blank" >
					Sapere aude Gedanken zur Migration und zum eigenständigen Denken (reupload 2019)
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=Bwt025WSxAQ" target="_blank" >
					WHO wählt Nordkorea in den Exekutivrat! 12.06.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=zexHjK73T-0" target="_blank" >
					MARKUS KRALL EXPLODIERT MIT UNFASSBARER BOTSCHAFT! 07.06.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=9_dKXEPJs5s" target="_blank" >
					WHO will neuen Pandemievertrag - TE Wecker am 04.06.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://report24.news/diktatur-nordkorea-und-ukraine-ins-fuehrungsgremium-der-who-gewaehlt/?feed_id=31045" target="_blank" >
					Diktatur Nordkorea und Ukraine ins Führungsgremium der WHO gewählt 03.06.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://apolut.net/who-mitglieder-beschliessen-resolution-zur-manipulation-der-oeffentlichen-meinung-von-norbert-haering/" target="_blank" >
					WHO-Mitglieder beschließen Resolution zur Manipulation der öffentlichen Meinung 03.06.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=6kWqAAMxnVw" target="_blank" >
					Dr. Markus Krall erklärt, wie es in Deutschland weitergeht 03.06.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://twitter.com/shomburg/status/1664145376490795010?s=21" target="_blank" >
					Die EMA will neue Coronaimpfstoffe OHNE klinischen Nachweis von Wirksamkeit und Sicherheit zulassen 01.06.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=REc4QeIB5WQ" target="_blank" >
					MARKUS KRALL EXPLODIERT MIT UNFASSBARER BOTSCHAFT ! 27.05.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=CYrRjnN0AbM" target="_blank" >
					Ukraine-Geheimdienstchef gesteht Tötung Russischer Zivilisten - Weltwoche Daily DE, 23.05.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=Rmb70cDiUGM&t=10s" target="_blank" >
					Dressiertes Nutzvieh: So behandelt uns die Politik. Gast: Dr. Valeria Petkova 17.05.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=y27UFMZwJJg" target="_blank" >
					Operation: Angst und soziale Ausgrenzung 08.05.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=iKNtEMxDCj4" target="_blank" >
					Stromerzeugung statt Nahrungsmittel 05.05.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=HgZrZtWagGE" target="_blank" >
						Biontechs Geständnis: Verbrecher im Staatsauftrag? 02.05.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=Yqlft-Viilo" target="_blank" >
					AUFGEPASST: Das muss jetzt jeder Wissen! 29.04.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=nV3beDt_AB4" target="_blank" >
					Migration: 2/3 der Migranten seit 2015 ohne Job - warum? Weil es gewollt ist! 24.04.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=5gdiDUY0Ors" target="_blank" >
					Lauterbachs Lügen: Eine kurze Geschichte des Impfbetruges. Gast: Dr. Kay Klapproth 19.04.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=3wH0-udZm4k" target="_blank" >
					ARD Doku: Deutschland schaltet ab - der Atomausstieg und die Folgen - Reaction 13.04.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=araGrojEuvk&t=6s" target="_blank" >
					Klimawandel größtes Problem der Deutschen! Gehirnwäsche wirkt... 08.04.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=DbznbhO2HmI" target="_blank" >
					Haltung im Gehirn / Nacktes Niveau 01.04.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=sXezay0CExI" target="_blank" >
					Die tiefere Ursache der Tragödie von C. Arvay:  Moralischer Narzissmus – Rückkehr zum Religionskrieg 26.03.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=qMD0oWZj7SI" target="_blank" >
						Der ganz GROßE CRASH KOMMT! Carlos A. Gebauer DECKT AUF, was FALSCH läuft. 25.03.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=JRk0zRLe1U8" target="_blank" >
					Gib mir deine Daten und ich zeige dir, was du darfst 23.03.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=UvWTjQao4K0" target="_blank" >
					EU-Zwangssanierung beschlossen - beginnt die Haus-Enteignung? 18.03.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=laIq92nEvic" target="_blank" >
					Friedensengel Xi Jinping - Weltwoche Daily DE, 17.03.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=_hV0bId3G3k" target="_blank" >
					Dr. Daniele Ganser: Wem soll man glauben (Hannover 9.3.23)
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=NSYsyq9YvuU" target="_blank" >
					Zukunft: WHO übernimmt die Macht | Corona und wie es weiter geht 15. März 2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=dbtjdumtpMI" target="_blank" >
					Staatsverbrechen Impfbetrug: Wer sind die Drahtzieher? Gast: Dr. med. Gunter Frank 15. März 2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=9p4crZpk8MM" target="_blank" >
					Karl Lauterbach gibt schwere Impfschäden zu! Claudius Fabig: Kein Vertrauen in Regierung! 13. März 2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=Jlbk2gZaO1s" target="_blank" >
					"Ich hasse Weiße" - die JF mit einer Sammlung wichtiger Zitate, die man sich merken sollte. 13. März 2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=uot40p-t6C0" target="_blank" >
					Medienschau: Montag, 13. März 2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=nz87MNShQlw" target="_blank" >
					Willkommen im Cancel-Culture-Club! 12.03.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=vOUwx38Ozzo" target="_blank" >
					Deutschland: Die grosse Demokratie-Simulation - Weltwoche Daily DE, 07.03.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=FB53hveEJug" target="_blank" >
					"Auch die Kirchen kriegen den Hals nicht voll!" -Peter Hahne im Gespräch - TE Wecker am 05.03.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=32950CJeuzA" target="_blank" >
					Tyrannei der Selbstgerechten - Nur noch eine Meinung erlaubt? | Kurzfassung 03.03.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=u_PDiNcRBD0" target="_blank" >
					Nordstream: Ungarn fordert Uno-Aufklärung des skandalösen Anschlags - Weltwoche Daily DE, 02.03.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=rXFGStOYnPw" target="_blank" >
					Die Widerworte der "Schwierigen" - Ruderboot #12 12.02.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://auf1.tv/stefan-magnet-auf1/anschlag-durch-who-das-was-jetzt-auf-uns-zukommt-ist-noch-viel-brutaler/" target="_blank" >
					Anschlag durch WHO: Das, was jetzt auf uns zukommt, ist noch viel brutaler! 14.02.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://tkp.at/2023/02/13/sinkende-lebenserwartung-in-deutschland-aerzteverband-fordert-sofortigen-impfstopp/" target="_blank" >
					Sinkende Lebenserwartung in Deutschland: Ärzteverband fordert sofortigen Impfstopp 13.02.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=aL2LpkeZ1_E&list=RDCMUCq-b0dwW97YRZWgSCikWQRA&start_radio=1" target="_blank" >
					USA sprengten Nordstream-Pipelines. Helfer Norwegen - Weltwoche Daily DE, 09.02.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=UZfP0IG1-u4" target="_blank" >
					Polizeipräsident a. D. Uwe Kranz über schockierende Übersterblichkeit in Deutschland! 05.02.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=pmfVmiK1c20" target="_blank" >
					So zynisch: US-Politikerin freut sich über Nord-Stream-Sprengung - Weltwoche Daily DE, 08.02.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=izT6m9LcJSI" target="_blank" >
					Insekten: Ekelessen oder Feinkost? - Tichys Einblick Talk 03.02.2023
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=B3mk8QSZInE" target="_blank" >
					Was ist der "Great Reset"?  Die beste Erklärung, die ich je gehört habe. Nichts für schwache Nerven. Sommer 2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=_VmvmI5CkBQ" target="_blank" >
					Der Schwab und die Welt
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=uwkWLgvfaNE" target="_blank" >
					Prof. Werner Bergholz- Die Corona-Salafisten
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=_vbg0uyXK2o" target="_blank" >
					Wie antisemitisch waren die Corona-Demos wirklich? (Raphael Bonelli) 22.12.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=YaNjiJJ93pw" target="_blank" >
					Die Wahrheit über die NEUE Flüchtlingskrise // Faeser leugnet Migrations-Probleme! 22.12.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=q3EwjDzBIfY" target="_blank" >
					"Die Politik der Furcht entmündigt!" 14.12.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=nqtEBULPLAY" target="_blank" >
					Sprunghafter Anstieg 2021 von „plötzlichen Toten“ – Analyse der KBV-Daten und der Kritiken ?.12.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=J4pYkEE2a3k" target="_blank" >
					Carsten Stahl spricht volles Rohr! - "Ihr Politiker seid das Letzte!" 04.12.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://telegra.ph/Es-geht-um-den-Umbau-der-freien-Wirtschaft-in-eine-grüne-Planwirtschaft-12-04" target="_blank" >
					Es geht um den Umbau der freien Wirtschaft in eine grüne Planwirtschaft 04.12.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=Rq8n1pZLMwY" target="_blank" >
					Twitter stützte Wahl Bidens durch Zensur 04.12.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=kzP0i2m2eHA&t=1s" target="_blank" >
					Wir befinden uns im postmodernen Totalitarismus! 28.11.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.auf1.tv/stefan-magnet-auf1/corona-lage-impf-massentoetung-alles-kommt-ans-licht/" target="_blank" >
					Corona-Lage: Impf-Massentötung? Alles kommt ans Licht! 26.11.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=BZs9kUm8zUI" target="_blank" >
					Niederlande: Staat droht Bauern mit Enteignung! Ist das noch Staat, oder schon Mafia? 02.12.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=tTGnbc4nuN4" target="_blank" >
					Exegese der Unmensch-Werdung 20.11.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=FBfMp0iO9uE" target="_blank" >
					Schmink dir dein Fleisch ab! 17.11.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=FtdAEeAzwaE" target="_blank" >
					Wir wurden mit den Corona-Daten getäuscht 09.11.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=7YqP0wK30JA" target="_blank" >
					Lauterbach gibt Corona-Fehler zu: „Kitas waren keine Infektionsherde“ 04.11.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=9C15T0768xc" target="_blank" >
					GREAT RESET: Sie erpressen die Bürger zur digitalen ID 30.10.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=ZEMxamJhARk" target="_blank" >
					Mädchen zu Jungs: Angriff auf unsere Kinder? Tichys Einblick Talk am 27.10.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=DcEedtA02oY" target="_blank" >
						Basta-Kanzler Scholz - Weltwoche Daily DE 24.10.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/shorts/yfROIe59YOU" target="_blank" >
						Pfizer 24.10.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=cOFHOlr1LZQ" target="_blank" >
					Erstmals entschuldigt sich Politikerin bei Ungeimpften für Diskriminierung 24.10.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=bQNsHivR9AU" target="_blank" >
					Von wegen cool und öko - wie die Grünen Wirtschaft und Natur zerstören 20.10.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=CFRSR5OJOrs" target="_blank" >
					Wie soll man in so einer Welt noch glücklich werden? (Raphael Bonelli) 20.10.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=7UaqLm6hO4U" target="_blank" >
						"Das ist mein Land und du bist Gast hier" - Rassismusskandal in Berlin 19.09.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=_CjIB-wVTus" target="_blank" >
					Irre: Facebooks deutsche Vollstrecker zensieren Biden, weil er sagt, dass die Pandemie vorbei ist. 19.09.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=XEsqrs-IKM8" target="_blank" >
						Durchsicht: Lauterbachs Magie im Bundesrat 18.09.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=Cp9dQj4qSe0" target="_blank" >
						Faeser und ARD-Chef Gniffke: So vertuschen sie Gewalt von Islamisten 16.09.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=NDgH66gMyn8" target="_blank" >
					Der König will den <strong>Great Reset</strong> 13.09.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=a4YphkIvIQo" target="_blank" >
					Unglaublich: Politik und Medien leisten Abbitte bei Maßnahmen-Kritikern – aber leider nur im Ausland 29.08.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=D8My8x7XmSg" target="_blank" >
						Ricarda Lang sieht Klimapolitik als Hebel zur Macht 17.09.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=yhlNwlW9LXg" target="_blank" >
						Lauterbach schlägt wieder Corona-Alarm: „Es verschlägt einem die Sprache“ 25.08.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=2lQ43phefrw" target="_blank" >
					„Wir können uns nicht mehr ernähren“ | Anthony-Robert Lee  23.08.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=vNw4S1d6MHk" target="_blank" >
					Scholz: „Niemand hat vor, dass auf Demonstranten geschossen wird“  24.08.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://tkp.at/2022/08/21/wef-empfiehlt-microchip-implantate-fuer-kinder/" target="_blank" >
					WEF empfiehlt Microchip-Implantate für Kinder  21.08.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://auf1.tv/elsa-auf1/sehr-viele-babys-werden-sterben-prof-bhakdi-warnt-vor-neuen-mrna-impfungen/" target="_blank" >
						„Sehr viele Babys werden sterben“: Prof. Bhakdi warnt vor neuen mRNA-Impfungen  18.08.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=Umowp0Jeaug"  target="_blank">
						Wer regiert die Welt? <strong>Der Große Reset</strong> Die Durchführung, die Zusammenhänge - Ernst Wolff 24.05.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://auf1.tv/nachrichten-auf1/prof-soennichsen-ueber-corona-impfungen-groesster-medizinskandal-aller-zeiten/" target="_blank" >
					Prof. Sönnichsen über Corona-Impfungen: „Größter Medizinskandal aller Zeiten“  18.08.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=wYf-3PhzAJM"  target="_blank">
				DER PERFIDE PLAN DES WORLD ECONOMIC FORUM 02.08.2020
			</a>	

			<a className="videoText"  rel="noopener" href="https://apolut.net/sucharit-bhakdi-bedrueckende-nachrichten/" target="_blank" >
				Sucharit Bhakdi – Bedrückende Nachrichten 17.05.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://auf1.tv/systemfehler-geldsystem-auf1/systemfehler-geldsystem-wer-regiert-die-welt/" target="_blank" >
				Systemfehler Geldsystem: Wer regiert die Welt? 17.04.2022	
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=h1q9-8nV3aM" target="_blank" >
			Mit dem WHO-Pandemievertrag in den autoritären Transhumanismus   07.04.2022
			</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=Oyp5fbVWzys" target="_blank" >
					Philipp Alsleben, zur Genesung der Menschenwürde, die Verantwortung in die Macht bringen 15.08.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=OWnQsZfzqjA" target="_blank" >
						Zerstörer am Werk…  27.07.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://auf1.tv/stefan-magnet-auf1/reiner-fuellmich-die-verbrechen-offenlegen-dann-haben-sie-keine-chance-gegen-uns/" target="_blank" >
					Reiner Fuellmich: Die Verbrechen offenlegen, dann haben sie keine Chance gegen uns   13.07.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://pressecop24.com/juristen-schlagen-alarm-die-who-macht-uns-zu-sklaven-im-dauer-notstand/" target="_blank" >
					Juristen schlagen Alarm! Die WHO macht uns zu Sklaven im Dauer-Notstand! 03.06.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://regelungstechnik.konradober.de/" target="_blank" >
						Wir sind im Exil  27.07.2022
					</a>

					<a className="videoText"  rel="noopener" href="https://twitter.com/tagesthemen/status/1542976798392291328" target="_blank" >
						Tagesthemen Kommentar   01.07.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=1tWDW5CB5To" target="_blank" >
						Der Evaluationsbericht im Detail - es ist der Hammer!   02.07.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=hQW7W2O_7jI" target="_blank" >
					Premierminister von Malaysia, Dr. Mahathir Mohamad, auf der intern. Konferenz "NEW WORLD ORDER"  19.10.2021
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=x-KVcNFJXzE" target="_blank" >
						Unser Grundgesetz nach Scheitern von Great Reset & Agenda 2030   17.06.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://reitschuster.de/post/die-uebersterblichkeit-im-jahr-2021-deutlich-gestiegen/" target="_blank" >
						Übersterblichkeit im Jahr 2021 deutlich gestiegen 03.07.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.zdf.de/politik/berlin-direkt/berlin-direkt-vom-22-mai-2022-100.html" target="_blank" >
						Erstaunlich, das ZDF merkt was. Ab min 14.04 vierter Zeitpunkt 22.05.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=i1HW7yLEjBk" target="_blank" >
						Totale Überwachung: Psychiater reagiert auf das "Sozialkredit-System" (Raphael Bonelli) 17.05.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=wZ7OXNvfAa4" target="_blank" >
						Schockierende Zahlen - die DAK Kinder- und Jugendstudie 29.05.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://apolut.net/sucharit-bhakdi-bedrueckende-nachrichten/" target="_blank" >
						Sucharit Bhakdi – Bedrückende Nachrichten 17.05.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://report24.news/aufgedeckt-alle-3-800-absolventen-von-klaus-schwabs-globalistischen-wef-ausbildungsprogrammen/" target="_blank" >
					Aufgedeckt: Alle 3.800 Absolventen von Klaus Schwabs globalistischen WEF-Ausbildungsprogrammen 10.05.2022
					</a>

					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=iBtOrjulS8c" target="_blank" >
						Entfremdung 30.04.2022	
					</a>
					<a className="videoText"  rel="noopener" href="https://reitschuster.de/post/herzentzuendungen-bei-geimpften-haeufiger-als-bei-nicht-geimpften/" target="_blank" >
						Herzentzündungen bei Geimpften häufiger als bei Nicht-Geimpfte 29.04.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?app=desktop&v=gKqzpzjCQKg" target="_blank" >
						Was ist in den letzten beiden Jahren passiert? (Raphael Bonelli) 26.04.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=iRo92fVBnfU" target="_blank" >
						Biontech zweifelt am eigenen Produkt? 24.04.2022 Dieses einfache Vorlesen aus dem Geschäftsbericht, reicht zur Zensur!!!
					</a>
					<a className="videoText"  rel="noopener" href="https://www.ardmediathek.de/video/umschau/impfkomplikationen-mehr-schwere-nebenwirkungen-als-gedacht/mdr-fernsehen/Y3JpZDovL21kci5kZS9iZWl0cmFnL2Ntcy8xNDk3YThlYi1mNTVjLTRkYjYtYTg5ZC05NzcyNmIwYTBjZTM" target="_blank" >
					<strong>mdr</strong> : Impfkomplikationen: Mehr schwere Nebenwirkungen als gedacht? 26.04.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=O7MGjDB_rhk" target="_blank" >
						<strong>Expertenhearing zur Impfpflicht im Gesundheitsausschuss:</strong> Expertenhearing zur Impfpflicht im Gesundheitsausschuss: Das Statement von Dr. Strasser I Teil 1 22.04.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=q44VVgbEyrY" target="_blank" >
					<strong>Expertenhearing zur Impfpflicht im Gesundheitsausschuss:</strong> Das Statement von Dr. Strasser I Teil 2 22.04.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=2oeJd9g9tXI" target="_blank" >
					<strong>Expertenhearing zur Impfpflicht im Gesundheitsausschuss:</strong> Das Statement von Dr. Strasser I Teil 3 22.04.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=4BcUyMxsYac" target="_blank" >
					Unfassbare Kollateralschäden durch Corona-Maßnahmen eingeräumt! (Marcus Franz + Raphael Bonelli) 09.04.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=FJ8iOwXEXxs" target="_blank" >
						2022 März Epoch Times Interview Prof. Dr. Dr. Haditsch 18.03.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.transparenztest.de/post/ukhsa-daten-zeigen-absurditaet-einer-impfpflicht-fuer-ueber-50jaehrige-auf" target="_blank" >
						UKHSA Daten zeigen Absurdität einer Impfpflicht für über 50 Jährige auf 04.04.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://odysee.com/@reitschuster:3/220301-matysik:a" target="_blank" >
						Mangelnde Qualitätskontrolle und Geheimniskrämerei bei den Impfstoffen? Prof. Matysik im Interview 08.03.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.wochenblick.at/corona/studien-zeigen-ivermectin-viel-wirksamer-gegen-covid-als-gedacht/" target="_blank" >
					Studien zeigen: Ivermectin viel wirksamer gegen Covid als gedacht 09.03.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.berliner-zeitung.de/news/wissenschaftler-darum-ist-die-impfpflicht-verfassungswidrig-li.216116" target="_blank" >
						Wissenschaftler: Darum ist die Impfpflicht verfassungswidrig 07.03.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.mdr.de/wissen/corona-covid-anteil-von-geboosterten-auf-intensivstationen-nimmt-rasant-zu-100.html" target="_blank" >
						MDR: Anteil von Geboosterten auf den Intensivstationen nimmt rasant zu 07.03.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://reitschuster.de/post/der-fussabdruck-der-mrna-impfung/" target="_blank" >
						Der Fußabdruck der mRNA-Impfung 05.03.2022
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=00OKDDGhVP4" target="_blank" >
						Maskenzwang in Schulen , Bill Gates und China, digitaler Impfpass | Der Kaiser ist nackt 02.03.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.welt.de/politik/deutschland/article237236519/Nach-Aussagen-zu-Impfnebenwirkungen-Vorstand-der-BKK-ProVita-ist-fristlos-gekuendigt.html" target="_blank" >
					Vorstand der BKK-ProVita ist fristlos gekündigt 01.03.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.berliner-zeitung.de/news/impffolgen-krankenkasse-bkk-schreibt-brief-an-paul-ehrlich-institut-li.213676" target="_blank" >
					Impffolgen: Krankenkasse BKK schreibt Brief an Paul-Ehrlich-Institut 24.02.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=v7OjOU0zbs4" target="_blank" >
						Tichys Ausblick - "Das Maß ist voll“ 17.02.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://reitschuster.de/post/uebersterblichkeit-durch-die-impfung/" target="_blank" >
						Mehr Tote im zweiten Habjahr 2021 16.02.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=BYscdRhhy38" target="_blank" >
						Peter Weber Live - Wollt ihr die Menschheit ausrotten? 15.02.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.auf1.tv/stefan-magnet-auf1/neueste-erdrueckende-beweislage-covid-impfung-brandgefaehrlich/" target="_blank" >
					Neueste, erdrückende Beweislage: Covid-Impfung brandgefährlich 12.02.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://reitschuster.de/post/meta-studie-lockdown-und-schulschliessungen-praktisch-wirkungslos/" target="_blank" >
						Von renommierter Johns-Hopkins-Universität: Lockdown und Schulschließungen praktisch wirkungslos 02.02.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=8Vy64EpGpZY" target="_blank" >
						Selig, die ihr euch gegen medizinische Experimente stellt - P. Damian OCist 14.02.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=IIHDPGP4XhQ" target="_blank" >
						Pandemie: Strategie und Impfpflicht 16.01.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=9UlLPJYwX8c" target="_blank" >
						Heiko Schönings groẞe enthüllung 12.01.2022
					</a>
					<a className="videoText"  rel="noopener" href="https://rumble.com/vr4emv-interview-paul-brandenburg.html" target="_blank" >
						Dr. Paul Brandenburg über die Corona-Maßnahmen 22.12.2021
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=DJ5M0Q6flYg" target="_blank" >
						Der neue Moralismus ist dröhnende Leere - Weltwoche Daily Deutschland, 21.12.2021
					</a>					
					<a className="videoText"  rel="noopener" href="https://www.welt.de/politik/ausland/plus235616866/Brasilien-Kaum-ist-Corona-fast-besiegt-kommt-ploetzlich-die-Grippe.html" target="_blank" >
						Corona fast besiegt – und plötzlich kommt die Grippe  15.12.2021
					</a>	
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=SJqGEdVvXp0" target="_blank" >
						Brisante Enthüllungen: Diese Corona-Fakten werden zensiert!   12.12.2021
					</a>									
					<a className="videoText"  rel="noopener" href="https://www.aerzteblatt.de/nachrichten/129920/34-Krankenhaeuser-werden-mit-Mitteln-aus-Strukturfonds-geschlossen" target="_blank" >
						Ärzteblatt: 34 Krankenhäuser werden mit Mitteln aus Strukturfonds geschlossen  10.12.2021<br/> Überlastung des Gesundheitssystems?
					</a>					
					<a className="videoText"  rel="noopener" href="https://reitschuster.de/post/impfpflicht-welcome-corona-leugner-als-moerder/" target="_blank" >
						„Corona-Leugner“ als Mörder<br/>Menschenrechtler auf Abwegen  10.12.2021
					</a>
					<a className="videoText"  rel="noopener" href="https://pathologie-konferenz.de" target="_blank" >
						Pathologie Konferenz Reutlingen Teil 2  04.12.2021
					</a>
					<a className="videoText"  rel="noopener" href="https://odysee.com/@hipsterious:3/Tod-durch-Impfung---Teil-1---Undeklarierte-Bestandteile-der-COVID-19-Impfstoffe:b" target="_blank" >
						Pathologie Konferenz Reutlingen Teil 1  28.09.2021
					</a>

					<a className="videoText"  rel="noopener" href="https://t.me/bitteltv/11680" target="_blank" >
						Na da schau her, jetzt merkt es auch Drosten 08.11.2021
					</a>
					<a className="videoText"  rel="noopener" href="https://rumble.com/vouqx3-rki-stellt-im-kleingedruckten-corona-kurs-auf-den-kopf.html" target="_blank" >
						RKI stellt im Kleingedruckten Corona-Kurs auf den Kopf 07.11.2021
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=i5YnYw38k90" target="_blank" >
						Kantinen-Segregation - Stück für Stück in die Apartheit 01.11.2021
					</a>
					<a className="videoText"  rel="noopener" href="https://wirtube.de/w/vWNVx32fMEc6mLBqz35LDQ" target="_blank" >
						Woran glaubst Du noch? 26.10.2021
					</a>
					<a className="videoText"  rel="noopener" href="https://report24.news/holocaust-ueberlebende-unterstuetzen-prof-bhakdi-gegen-falsche-vorwuerfe/?feed_id=5386" target="_blank" >
						Holocaust-Überlebende unterstützen Prof. Bhakdi gegen falsche Vorwürfe 13.09.2021
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=ZKcDLSRUxfI" target="_blank" >
						Der Staat begeht Machtmissbrauch | Ralf Ludwig
					</a>

					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=k0sRNnyktYY" target="_blank" >
					„Karl Lauterbach darf unter keinen Umständen Gesundheitsminister werden“ 07.10.2021
					</a>
					<a className="videoText"  rel="noopener" href="https://reitschuster.de/post/ard-mitarbeiter-hat-es-satt-und-packt-aus-ich-kann-nicht-mehr/" target="_blank" >
						ARD-Mitarbeiter hat es satt und packt aus: „Ich kann nicht mehr“ 05.10.2021
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=rGfdlOsY6Pc" target="_blank" >
						Schweden genießen ihre Freiheit 30.09.2021
					</a>
					<a className="videoText"  rel="noopener" href="https://report24.news/jetzt-auch-in-norwegen-alle-covid-beschraenkungen-aufgehoben/" target="_blank" >
					Jetzt auch in Norwegen: Alle Covid-Beschränkungen aufgehoben 28.09.2021
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=llWpA336vLM" target="_blank" >
						Nur zwei Prozent Corona-Patienten 2020 in den Kliniken – und die Regierung schweigt zur Skandal-Zahl 21.09.2021
					</a>
					<a className="videoText"  rel="noopener" href="https://www.welt.de/politik/deutschland/plus233426581/Corona-bei-80-Prozent-der-offiziellen-Covid-Toten-wohl-nicht-Todesursache.html" target="_blank" >
						„Corona bei 80 Prozent der offiziellen Covid-Toten wohl nicht Todesursache“ 30.08.2021
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=4KD_3igxz0k" target="_blank" >
						Sucharit Bhakdi erklärt die Wirkungen der neuartigen Impfungen 03.08.2021
					</a>
					<a className="videoText" rel="noopener"  href="https://reitschuster.de/post/covid-todesfaelle-in-schweden-praktisch-auf-null/" target="_blank" >
						Covid-Todesfälle in Schweden praktisch auf Nul 30.07.2021
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=H5qcpRTS9lA" target="_blank" >
						SAT1-Live Chefredakteur Richard Kremershof 13.04.2021
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=baV5kX4gUNM" target="_blank" >
						RTL : PCR-Test ist unbrauchbar! 21.06.2021
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=JzW2mOZm8jg" target="_blank" >
						Angst tötet  Bonelli 11.07.2021
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=-iKznxziL7Q" target="_blank" >
						FPÖ : PCR-Test ist unbrauchbar! 21.06.2021
					</a>
					<a className="videoText" rel="noopener"  href="https://tkp.at/2021/06/28/gericht-in-portugal-nur-09-der-verifizierten-faelle-starben-an-covid/" target="_blank" >
						Gericht in Portugal: nur 0,9 % der „verifizierten Fälle“ starben an COVID 28.06.2021
					</a>
					<a className="videoText" rel="noopener"  href="https://odysee.com/@Punkt.PRERADOVIC:f/Lausen:2" target="_blank" >
						Intensivbetten-Skandal  14.06.2021
					</a>
					<a className="videoText" rel="noopener"  href="https://t.me/davebrych_public/8307" target="_blank" >
						Die US Gesundheitsbehörde CDC räumt ein, über die Anzahl der Todesfälle gelogen zu haben.
					</a>

					<a className="videoText" rel="noopener"  href="https://www.nordkurier.de/mecklenburg-vorpommern/rechtsmediziner-zweifeln-an-der-zahl-der-corona-toten-1543142804.html" target="_blank" >
						Rechtsmediziner zweifeln an der Zahl der Corona-Toten 15.04.2021
					</a>									
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=lcbBOtYiJV0" target="_blank" >
						Dr. Bonelli - Kinder	23.03.2021
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=eTZV4VldUIg" target="_blank" >
						Keine Masken für Mütter 06.052021
					</a>					
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=RWRyMbuMqRY" target="_blank" >
						Monika Gruber - Kinder 04.05.2021
					</a>

					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=B57Sb0DJwBA" target="_blank" >
						ARD 07.10.2020
					</a>			
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=O7aPL5-G_p8" target="_blank" >
						SAT1: Dr. Brandenburg 22.12.2020
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=PjukhAkr8Ws" target="_blank" >
						Intensivpfleger zerlegt Spahns Corona-Politik 30.04.2021
					</a>					
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=L8synzDTCw8" target="_blank" >
						<strong>Amnesty International</strong> kritisiert <br/>07.04.2021
					</a>						

					<a className="videoText" rel="noopener" href="https://www.youtube.com/watch?v=ZX9QdZL4G-s" target="_blank" >
						Sven Armbrust - Chefarzt Kinder & Jugendmedizin   18.03.2021
					</a>							
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=VMMqgVNfrEU" target="_blank" >
						Anne Will: Julian Nida-Rümelin:<br/>"Die WeltHungerHilfe erwartet <strong>30 Millionen zusätzliche Hungertote"</strong> 13.12.2020
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=jpv0rXket2E" target="_blank" >
						"Die Todesursache Nummer eins heißt Einsamkeit" 18.03.2018
					</a>					
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=YRZBmV9dcLU" target="_blank" >
						Profiteure der Angst 03.05.2021
					</a>					
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=OeOsL96W34c" target="_blank" >
						Krankheit egal, Hauptsache Covid 08.04.2021
					</a>						
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=d_Zy_i3nx_w" target="_blank" >
						WELT: Innenministerium bestellte Gutachten 09.02.2021
					</a>										
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=LsXM502SpiU" target="_blank" >
						RTV Talk: Corona - Stimmt die Richtung? 09.01.2021
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=l866wsIs9N8" target="_blank" >
						Wissenschaft widerlegt den Nutzen vom LOCKDOWN! 14.01.2021
					</a>					
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=BwSrEXYQfJE&feature=youtu.be" target="_blank" >
						Die Überlastung des Gesundheitssystems
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=O0iQo-pmh8c" target="_blank" >
						Noch nie so viele Patienten mit Depressionen 28.01.2021
					</a>					
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=rJzeZ-TRMRI" target="_blank" >
						Sterbezahlen Deutschland 22.01.2021
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=ng2XWxOGGIk&list=UUYFJQqQf7yuUBlLExlvW_iA" target="_blank" >
						Sterbezahlen Österreich 22.01.2021
					</a>												
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=ogTqxJt_Lns" target="_blank" >
						"Corona-Tote": Ein Bestatter spricht Klartext<br/>und ein Fernsehsender schneidet ihn aus der Sendung 18.01.2021
					</a>										
					<a className="videoText" rel="noopener"  href="https://arteptweb-a.akamaihd.net/am/ptweb/098000/098100/098118-000-A_SQ_0_VOA_05390847_MP4-2200_AMM-PTWEB_1R8Yd1CzJWB.mp4?fbclid=IwAR3T_Mdv6DyhyRuooN1_AaQ8COoTNOM1g6Pump0jD64DEV0gcZ86OKw8urM" target="_blank" >
						ARTE Frankreich, Deutschland, Schweden
					</a>																		
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=-9XTOg_rkOE" target="_blank" >
						Prof. Dr. Klaus Püschel	16.09.2020
					</a>					
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=XnlT3rPNUp0" target="_blank" >
						Dr. Wodarg	17.03.2020
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=XWnbSv2aUP4" target="_blank" >
						Ärztekammer - „Schluss mit Corona-Panik"	21.09.2020
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=RVhInGSGT80" target="_blank" >
						Was passiert hier eigentlich gerade?	12.12.2020
					</a>					
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=kj3LxLv-3gI" target="_blank" >
						Schweden  28.12.2020
					</a>
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=eOSiy2m2vmY&list=UUYFJQqQf7yuUBlLExlvW_iA" target="_blank" >
						Schweden Sterbestatiskik 28.01.2021
					</a>							
					<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=YTv1TlLgz3M" target="_blank" >
						Hmm, ohne Lockdown solche Zahlen?<br/>Schweden Update 10.12.2020
					</a>											
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=Cxyrd_Duq90&t=2s" target="_blank" >
						Wo sind unsere kritischen Denker?
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=-opKoSh7lsk"  target="_blank">
						Untersuchungsausschuss Corona-Ausschuss<br/>
						Schlussstrich 2020  01.01.2021
					</a>					

					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=b5NsnjyWhqo"  target="_blank">
						RA Fuellmich Sammelklage	01.10.2020
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=YcWlRczjDQc"  target="_blank">
						Brisante Hinweise zum Ursprung der Pandemie (Bonelli) 16.01.2021
					</a>					
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=iZUPevF1JJo" target="_blank" >
						Lutz Männel	20.09.2020
					</a>
					<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=ygDoiJICtj0"  target="_blank">
						Amtseid der Kanzlerin
					</a>					
					<br/>
			    </div>
    
			</div>
			<div className="Startbilder">
				<img src={Leben} className="E" alt="Leben" />
				<div>
					<img src={Krankenhaus} className="E" alt="Krankenhäuser" />	
				</div>		
			</div>
		</div>
  );
};
}

export default Home;
